import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PrProductKitService extends ApiService {

    parents(params: any = {}): Observable<any> {
        return super.get('/pr-product-kits/parents', params);
    }

    index(params: any = {}): Observable<any> {
        return super.get('/pr-product-kits', params);
    }
}
